/**
 * Modulo: Accordion Scroll
 * Scroll automatico all'apertura di un accordion Bootstrap 5
 *
 */

export const initAccordionScroll = () => {

  const ACCORDION_SELECTOR = ".accordion-item .collapse";
  const HEADER_SELECTOR = ".accordion-header";

  jQuery(function ($) {
    const $accordions = $(ACCORDION_SELECTOR);

    if ($accordions.length === 0) {
      console.warn(
        "Nessun accordion trovato sulla pagina"
      );
      return;
    }

    console.log(`Accordion trovati → ${$accordions.length} 👍`);

    $accordions.on("shown.bs.collapse", function (e) {
      const $target = $(e.target);
      const offsetTop = $target.offset().top;
      const headerHeight = $target.prev(HEADER_SELECTOR).outerHeight() || 0;
      const scrollPos = $(document).scrollTop();
      const finalOffset = offsetTop - headerHeight - 200;

      if (scrollPos > finalOffset) {
        $("html, body").animate({ scrollTop: finalOffset }, "fast");
        console.log("↑ Scroll animato verso accordion aperto");
      }
    });
  });
}
